<template>
  <div class="row justify-content-center">
    <div class="col-12 col-sm-6 my-5">
      <h1 class="display-4 text-center mb-3">Zeppy PDV</h1>
      <p class="text-muted text-center mb-5">Informe seus dados para acessar</p>

      <form @submit.prevent="login">
        <Input v-model="auth.username" id="login-username" label="E-mail ou Celular" icon="far fa-user" />
        <Input v-model="auth.password" id="login-password" type="password" label="Senha" icon="fas fa-lock" />
        <button class="btn btn-lg w-100 btn-primary mb-3"> Entrar </button>
      </form>

      <div class="row">
        <div class="col text-left">
          <a href="https://zeppy.com.br/delivery?utm_source=pdv-login" class="text-muted small">Ainda não é cadastrado?</a>
        </div>
        <div class="col text-right">
          <a href="https://painel.zeppy.com.br/recuperar-senha?utm_source=pdv-login" class="text-muted small">Esqueceu sua senha?</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Input from '../components/Input/Index';

export default {
  name: 'Login',
  components: {
    Input,
  },
  data() {
    return {
      auth: {
        username: null,
        password: null,
      }
    }
  },
  methods: {
    fetchUser() {
      this.$store.dispatch('alerts/loadingShow');
      this.axios.get('auth/user').then((response) => {
        this.$store.dispatch('auth/setUser', response.data.data)
          .then(() => {
            if (this.$route.query.shop) {
              const shop = response.data.data.shops.find(item => item.id == this.$route.query.shop);
              this.$store.dispatch('shop/setShop', shop)
                .then(() => {
                  this.$router.push({ name: 'order.index' })
                })
              return;
            }

            if (response.data.data.shops.length > 0) {
              this.$router.push({ name: 'shop.select' })
            } else {
              this.$store.dispatch('shop/setShop', response.data.data.shops[0])
                .then(() => {
                  this.$router.push({ name: 'order.index' })
                })
            }
          })
      }).catch(() => {})
      .finally(() => {
        this.$store.dispatch('alerts/loadingHide');
      })
    },
    login() {
      this.axios.post('auth/login', { ...this.auth }).then((response) => {
        this.$store.dispatch('auth/setToken', response.data.data.access_token)
        this.fetchUser();
      }).catch(error => {
        this.$store.dispatch('alerts/alertShow', {
          type: 'danger',
          message: error.response.data.message
        })
      }).finally(() => {
        this.$store.dispatch('alerts/loadingHide');
      })
    }
  },
  mounted() {
    if (this.$route.query.token) {
      localStorage.setItem('access_token', this.$route.query.token)
    }

    this.$store.dispatch('auth/setToken', localStorage.getItem('access_token'))
    this.fetchUser();
  }
}
</script>
